export enum EventName {
  PageLoaded = 'page_loaded',
  PageScrolled = 'page_scrolled',
  TabClicked = 'tab_clicked',
  TabViewed = 'tab_viewed',
  PopupViewed = 'popup_viewed',
  SectionViewed = 'section_viewed',
  SectionScrolled = 'section_scrolled',
  CardViewed = 'card_viewed',
  CardClicked = 'card_clicked',
  BannerClicked = 'banner_clicked',
  CtaClicked = 'cta_clicked',
  PromocodeApplied = 'promocode_applied',
  IconClicked = 'icon_clicked',
  WidgetClicked = 'widget_clicked',
}

// export type EventNameType = keyof typeof EventName;

export enum EventCategoryName {
  Fastag = 'fastag',
  Oem = 'oem',
  Challan = 'challan',
  Fuel = 'fuel',
  Loan = 'loan',
  SpinAndWin = 'spin_and_win',
  Bbps = 'bbps',
  Servicing = 'servicing',
  Store = 'store',
  GiftVoucher = 'gift_voucher',
  CarSell = 'car_sell',
  CarBuy = 'car_buy',
  SellCar = 'sell_car',
  Community = 'community',
  IndiaKaPoll = 'india_ka_poll',
  MapParking = 'map_parking',
  JackpotSpin = 'jackpot_spin',
  Ppl = 'ppl_2025',
  EarnPetrol = 'earn_petrol',
  FuelBlast = 'fuel_blast',
  Money = 'Money',
  Mahakumbh = 'mahakumbh',
  CarLoan = 'car_loan',
  RedemptionPage = 'redemption_page',
  CarDealer = 'car_dealer',
  Reviews = 'reviews',
  Insurance = 'insurance',
  Experian = 'Experian',
  Enterprise = 'Enterprise',
  MyRewards = 'my_rewards',
  Dealer = 'dealer',
  Society = 'society',
  Pdi = 'PDI',
  RoadTrip = 'road_trip',
  CarWash = 'car_wash',
  HomeLoan = 'home_loan',
  Garuda = 'garuda',
  Signin = 'Signin',
  Business = 'business',
  Website = 'website',
  Discover = 'Discover',
  TestDrive = 'Test Drive',
  TestDriveBooking = 'test_drive',
  OttPlay = 'ottplay',
  Wallet = 'parkplus-wallet',
  Address = 'address',
  Valet = 'valet',
  Survey = 'survey',
  ApiError = 'api_error',
}

export enum EventScrollDirection {
  Vertical = 'vertical',
  Horizontal = 'horizontal',
}

export interface EventAttributes {
  category: EventCategoryName;
  pageName: string;
  tabName?: string;
  popupName?: string;
  sectionName?: string;
  scrollDirection?: EventScrollDirection;
  cardName?: string;
  bannerName?: string;
  ctaName?: string;
  promoCode?: string;
  position?: any;
  optionSelected?: string;
  vehicleId?: string;
}
